export const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";
export const CREATE_ORDER_FAIL = "CREATE_ORDER_FAIL";
export const FETCH_ORDERS_FAIL = "FETCH_ORDERS_FAIL";
export const FETCH_ORDERS_START = "FETCH_ORDERS_START";
export const CLEAR_ERROR = "CLEAR_ERROR";
